import { Component, ElementRef, Inject, OnDestroy, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, take } from 'rxjs';
import { ProductsService } from '@core/services/products/products.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { User } from '@core/interfaces/user.model';
import { LocalStorageService } from '@core/services/local-storage.service';
import { UtilsService } from '@core/services/utils/utils.service';
import { AppState } from '@core/store/app.reducer';
import { Store } from '@ngrx/store';
import { Car, CarsState } from '@core/interfaces/cars';
import * as ShoppingActions from '@core/store/shoppingCar/shoppingCar.actions';
import { Router } from '@angular/router';
import { GtmEventService } from '@core/analytics/gtm-events.service';
import { ChargingModalComponent } from '../charging-modal/charging-modal.component';
import { ErrorsMessageMassExcel, ExitMessageMassExcel } from 'src/assets/data/errors-message';
import { MessageEmptyErrorComponent } from '@shared/components/message-empty-error/message-empty-error.component';
import { ExcelAlertModalComponent } from '../excel-alert-modal/excel-alert-modal.component';

@Component({
  selector: 'app-excel-table-modal',
  templateUrl: './excel-table-modal.component.html',
  styleUrls: ['./excel-table-modal.component.scss'],
  host: {
    '(document:keydown)': 'handleKeyboardEvent($event)'
  }
})
export class ExcelTableModalComponent implements OnInit, OnDestroy{
  subscription!: Subscription;
  dataRecieved: any ;
  readonly navigator = window.navigator;
  dataForm!: FormGroup;
  limit: number = 0;
  actualLimit: number = 100;
  user!: User;
  sectorSelect: any;
  uploadProducts:any;
  @ViewChildren("referenceInput", { read: ElementRef }) referenceInput!: QueryList<
    ElementRef<HTMLInputElement>
  >;
  flagQuantity = false;

  readonly errors = [{
    type:1, message: 'El valor de la cantidad debe ser mayor a 0.'//0
  },{
    type:2, message: 'El SKU o la cantidad no son números.'//1
  },{
    type:3, message: 'La cantidad máxima del producto es de 999,999.'//2
  },{
    type:4, message: 'Producto no encontrado'//3
  },{
    type:5, message: 'La cantidad no puede estar vacía.'//4
  },{
    type:6, message: 'Descontinuado'//5
  },{
    type:7, message: 'No disponible temporalmente'//6
  }];
 
  isLoading: Boolean = false;
  uiSubscription!: Subscription;
  carsSubscription!: Subscription;
  readonly carsState: CarsState = { cars: [] };
  dialogChargingRef: any;
  readonly errorsMessageMassExcel = [ErrorsMessageMassExcel];
  readonly exitMessageMassExcel = [ExitMessageMassExcel];
  constructor(
    private readonly store: Store<AppState>,
    public readonly formB: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly renderer: Renderer2,
    private readonly productService: ProductsService,
    private readonly localStorageService: LocalStorageService,
    private readonly router: Router,
    private readonly _gtmEventService: GtmEventService,
    public readonly dialogRef: MatDialogRef<ExcelTableModalComponent>,
    @Inject(MAT_DIALOG_DATA) data
    ) {
      this.openedStart()
      this.dataRecieved = data;
    }
  ngOnInit(): void {
    this.loadData();
    this.initStore();
    this.initForm();
  }
  ngOnDestroy(): void {
    this.closedStart()
  }


  loadData(){
    // Cargar información de localstorage
    
    if(this.router.url !== "/main/subir-pedido"){
      this.user  = this.localStorageService.getItem("user").code;
      this.sectorSelect  = this.localStorageService.getItem("sectorSelect")
    }
    else {
      this.user  = this.localStorageService.getItem("clientSelect").code
      this.sectorSelect  = this.localStorageService.getItem("clientSelect")
    }
  }

  initStore(){
    // Inicializar Store
    this.uiSubscription = this.store.select('ui').subscribe(ui => this.isLoading = true)
    this.carsSubscription = this.store.select('carsState').subscribe(carsState => {
      if (carsState) {
        this.carsState.cars = [...carsState.cars]
      }
    })
  }

  initForm(){
    // Inicializar formulario con un form Builder
    this.dataForm = this.formB.group({
      products: this.formB.array([])
    });
    // Agregar 100 celdas al formulario
    for(let i = 0; i< 100; i++){
      this.addProduct()
    }
  }

  get products() {
    return this.dataForm.controls["products"] as FormArray;
  }

  addProduct(){
    const productForm = this.formB.group({
      sku: [''],
      quantity: [''],
    });

    this.products.push(productForm);
  }

  handleKeyboardEvent(e: KeyboardEvent) {
    // console.log(e)
    let key = e.key;
    let cmd_held = e.metaKey;
    let ctrl_held = e.ctrlKey;
    if((cmd_held || ctrl_held) && key.toLowerCase() == "v") {
      this.pasteEvent()
    }
  }

  async pasteEvent() {
    try {
      const text = await navigator.clipboard.readText();
      if (text) {
        this.setData(text);
      }
    } catch (error) {
    }
  }
  
  
  setData(s){
    let flagSecondColum = false
    const rowArray = s.trim().split(/\n/);
    let transforArr: any[] = [];
    rowArray.map((row)=> {
      const temp = row.split(/\t/);
      let tempArr: any[] = []
      if(this.flagQuantity){
        tempArr.push('')
        temp[0] ? tempArr.push(temp[0]) : tempArr.push('')
        flagSecondColum = true
      }else{
        temp[0] ? tempArr.push(temp[0]) : tempArr.push('')
        temp[1] ? tempArr.push(temp[1]) : tempArr.push('')
      }
      transforArr.push(tempArr)
    })
    this.limit = transforArr.length
    for(let i= 0; i < this.limit; i++){
      if(i >= this.actualLimit && i >= 100){
        this.addProduct()
      }
      if(!flagSecondColum){
        if (transforArr[i][0] != '') {
          this.products.controls[i].get('sku')?.setValue(transforArr[i][0]);
        }
      }
      if (transforArr[i][1] != "") {
        this.products.controls[i].get('quantity')?.setValue(transforArr[i][1]);
      }
    }
    if(this.actualLimit > this.limit){
      this.cleanOthers()
    }
    this.actualLimit = this.limit;
    flagSecondColum= false;
  }
  
  cleanOthers(){
    for(let i = this.actualLimit-1; i>= this.limit; i--){
      this.products.controls[i].get('sku')?.setValue('')
      this.products.controls[i].get('quantity')?.setValue('')
    }
  }

  checkData(){
    this.limit = 0;
    for(let i = 0; i < this.products.controls.length; i++){
      if(this.products.controls[i].value.sku != '' ||this.products.controls[i].value.quantity != ''){
        this.limit = i+1;
      }
    }
  }

  sendData(){
    this._gtmEventService.clickContinueButtonEvent();
    this.checkData();
    this.dialogRef.close();
    let dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    this.activeLoading();
    // Evaluando que haya almenos uno producto
    if(this.limit == 0){
      // La columna cantidad no debe estar vacia
      this.deactiveLoading();
    }else{
      
      let posibleProducts: any[] = []
      let skuProducts: any[] = []
      let skuError:any[] = []
      let products: any[] = this.checkProducts()
      products.forEach((product, index) => {
        
          const {skuFormat, quantityFormat, sku, quantity} = product
          
          if(quantity == ''){
            skuError.push({...product, position: product.originalPosition, error: this.errors[4]})
          }
          else if (skuFormat == 0) {
            skuError.push({...product, position: product.originalPosition, error: this.errors[3]})
          }
          else if(quantityFormat <= 0){
            skuError.push({...product, position: product.originalPosition, error: this.errors[0]})
          }else if (
            Number.isNaN(Number(skuFormat)) ||                // SKU no es número
            String(skuFormat).trim() === '' ||// SKU está vacío o solo espacios
            skuFormat < 0 ||                  // SKU es negativo
            this.searchSpecialCharacter(sku) || // SKU contiene caracteres especiales
            Number.isNaN(Number(quantityFormat)) ||           // Cantidad no es número
            !Number.isInteger(quantityFormat)  // Cantidad no es entero
          ) {
            skuError.push({
              ...product,
              position: product.originalPosition,
              error: this.errors[1], // 'El SKU o la cantidad no son números.'
            });
          }
          else if(quantityFormat > 999999 ){
            // preparando skus para validar
            skuError.push({...product, position: product.originalPosition,  error: this.errors[2]})
          }else{
            // damos formato a los productos
            posibleProducts.push(product)
            // Añadimos lista de sku validos
            skuProducts.push({sku: skuFormat, count: quantityFormat})
          }
        // }
      });
      if(products.length > 0){
        let data = {
          "code": this.user,
          "sector":this.sectorSelect.sector,
          "zone":this.sectorSelect.zone,
          "schema": this.sectorSelect.schema,
          "segment": this.sectorSelect.segment,
          "userType" :(this.localStorageService.getItem("user")?.type == 'Cliente')?'C':'S',
          "products": skuProducts
        }
        // console.log(data)
        let skuAvailable: any[] = []
        // Consultamos los SKUs disponibles:
        this.productService.setValidateSKU(data).pipe(take(1)).subscribe({
          next: (res: any) => {
            if(posibleProducts?.length !== 0 ){
              posibleProducts.forEach(product => {
                if(res){
                  const productFind = res.filter((productSearch) => product.sku == productSearch.sku);
                  
                  if(!productFind[0]){
                    skuError.push({...product, position: product.originalPosition, error: this.errors[3]})
                  }else if (productFind[0].discontinued && !productFind[0].newSku) {
                    skuError.push({...productFind[0], position: product.originalPosition, error: this.errors[5]})
                    
                  }else if (!productFind[0].discontinued && productFind[0].disableCode) {
                    skuError.push({...productFind[0], position: product.originalPosition, error: this.errors[6]})
                    
                  }else if (productFind[0].discontinued && productFind[0].newSku && productFind[0].recommendedProduct) {
                    skuError.push({...productFind[0], position: product.originalPosition, error: this.errors[5]})
                    skuAvailable.push(this.formatProduct(productFind[0].recommendedProduct, product.quantity));
                  }else{
                    //estos son los unicos que pasarán
                    skuAvailable.push(this.formatProduct(productFind[0], product.quantity));
                  }
                }else{
                  skuError.push({...product, position: product.originalPosition, error: this.errors[3]})
                }
              })
              if(skuError.length !== 0 ){
                let warnings: string[] = [];
                for (const warning of skuError) {
                  warnings.push(warning.error.message)
                }
                this._gtmEventService.viewWarningDisplaySkuEvent(warnings);
                dialogConfig.panelClass = 'excel-table-mass'
                dialogConfig.data = {
                  status:2,
                  skuError: this.orderForPosition(skuError),
                  validProductExists:skuAvailable?.length>0
      
                };
                let dialogRef = this.dialog.open(ExcelAlertModalComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(
                  (data: any) => {
                    if(data?.status == 1){
                      if(skuAvailable.length > 0){
                        this.addProductsInStore(skuAvailable,1);
                      }else{
                        // ERRROR
                        this._gtmEventService.viewErrorDisplaySkuEvent();
                        this.exit();
                      }
                    }
                  }
                );
              }else{
                this.deactiveLoading();
                if(skuAvailable.length > 0){
                  this._gtmEventService.viewVerificationOkEvent();
                  this.addProductsInStore(skuAvailable,2)
                }else{
                  this._gtmEventService.viewErrorDisplaySkuEvent();
                  // flujo donde nada paso.
                  dialogConfig.data = {status:7};
                  this.dialog.open(ExcelAlertModalComponent, dialogConfig);
                  this.exit();
                }
              }
            }
          },
          error: (e) => {
           this.showErrorModal();
            this.exit()
          },
          complete: () => {
            this.exit()
          }
        })
        
      }else{
        this.deactiveLoading();
      }
    }

  }
  
  checkProducts(){
    const listSkus: any = []
    const checkProducts:any  = []
    for(let i= 0; i < this.limit; i++){
      const quantity = this.products.controls[i].value.quantity;
      listSkus.push({
        sku: this.products.controls[i].value.sku,
        skuFormat: Number.parseInt(this.products.controls[i].value.sku),
        quantity: quantity.trim(),
        quantityFormat: Number.parseInt(quantity),
        position: i+1,
        originalPosition: i+1
      })
    }
    let position = 1
    
    listSkus.forEach((product, index) => {
      const filterProduct = checkProducts.find(localProduct => localProduct.sku == product.sku)
      if(!filterProduct){
        let tempQuantity = 0
        for(let i = index ; i < this.limit; i++){
          if(product.sku == listSkus[i].sku){
            if(!Number.isNaN(Number(listSkus[i].quantityFormat))){
              tempQuantity = tempQuantity + listSkus[i].quantityFormat
            }
          }
        }
        checkProducts.push({
          ...product,
          quantity: tempQuantity == 0 ? product.quantity : String(tempQuantity),
          quantityFormat: tempQuantity == 0 ? product.quantityFormat : tempQuantity,
          position: position,
        })
        position ++;
      }
    });
    this.limit = position - 1
    return checkProducts
  }
  orderForPosition(products){
    products = products.sort(this.compare_lname)
    return products
  }

  compare_lname( a, b ){
    if ( a.position < b.position){
      return -1;
    }
    if ( a.position > b.position){
      return 1;
    }
    return 0;
  }

  formatProduct(product, count){
    const sale_price = Number.isInteger(product.sale_price) ? product.sale_price: product.sale_price.replace(/[^0-9-.]/g, '');
    return {
      ...product,
      cashPrice: product.cash_price,
      creditPrice: product.credit_price,
      count: UtilsService.formatNumber(count),
      salePrice: UtilsService.formatTotalNumber(sale_price),
      buyUnd: product.buy_und,
      totalPrice: UtilsService.formatTotalNumber((count * Number.parseFloat(product.sale_price)).toFixed(2)),
      perceptionFlag: product.categoryName == 'Harinas' || product.category_name == 'Harinas'? 1 : 0,
      item_list_name: 'Copia y pega',
      item_list_id: 'COPIAYPEGA'
    }
  }


  addProductsInStore(products,type){
    this.uploadProducts = products;
    this.activeLoading()
    if (this.carsState.cars.length == 0) {
      // buscar nuevos productos
      // crear carro nuevo
      const car: Car = {
        unitBussines: this.sectorSelect.name,
        products: [...products]
      }
      this.carsState.cars.push(car)
      this.store.dispatch(ShoppingActions.setCar({ cars: this.carsState.cars }))
      type == 1 ? this.redirect() : this.showAddCarModal();
    } else {
      // buscar la unidad de negocio actual
      let ifBusinessCarExist = false
      const tempCars = this.carsState.cars.map(car => {
        if (car.unitBussines == this.sectorSelect.name) {
          // Buscar productos activos en carrito actual, sino existe agregar sino editar
          car = {
            ...car,
            products: this.searchProductInExistingCar(products,car)
          }
          ifBusinessCarExist = true
          return car
        }
        return car
        // console.log("carrito:", car)
      })
      if (!ifBusinessCarExist) {
        // sino existe
        const car: Car = {
          unitBussines: this.sectorSelect.name,
          products: [...products]
        }
        tempCars.push(car)
      }
      this.carsState.cars = [...tempCars]
      this.store.dispatch(ShoppingActions.setCar({ cars: this.carsState.cars }))
      type == 1 ? this.redirect() : this.showAddCarModal();
    }
  }

  searchProductInExistingCar(products, car) {
    let newListInCarProducts: any = []
    let newListInActiveProducts: any = [...products]
    let flagExist = false;
    car.products.forEach((productInCar) => {
      flagExist = false
      newListInActiveProducts.forEach((activeProduct, index) => {
        if (activeProduct.sku == productInCar.sku) {
          const replace = Number.isInteger(activeProduct.count) ? activeProduct.count: String(activeProduct.count).replace(/[^0-9]/g, '');
          const replace2 =  Number.isInteger(productInCar.count) ? productInCar.count: String(productInCar.count).replace(/[^0-9]/g, '');
          // producto existe
          let tempCount = Number.parseFloat(replace) + Number.parseFloat(replace2) > 999999
                          ? 999999
                          : Number.parseFloat(replace) + Number.parseFloat(replace2)
          let tempTotalprice = UtilsService.formatTotalNumber((tempCount * Number.parseFloat(productInCar.salePrice)).toFixed(2))
          const tempProduct = {
            ...productInCar,
            count: UtilsService.formatNumber(tempCount),
            totalPrice: `${tempTotalprice}`
          }
          newListInCarProducts.push(tempProduct)
          newListInActiveProducts.splice(index, 1)
          flagExist = true
        }
      })
      if (!flagExist) {
        newListInCarProducts.push(productInCar)
      }
    })
    return newListInCarProducts.concat(newListInActiveProducts)
  }
  exit(){
    this.deactiveLoading();
    this.dialogRef.close();
  }

  redirect(){
    this.exit();
    this.deactiveLoading();
    if(this.router.url === "/main/subir-pedido"){
      this.router.navigate(['/main/confirmacion']);
      return
    } else {
      this._gtmEventService.addProductCartEvent("ENTENDIDO", this.uploadProducts);
      this.router.navigate(['/tienda/mi-carrito']);
      return;
    }
  }
 
  activeLoading(){
  const dialogChargingConfig = new MatDialogConfig();
    dialogChargingConfig.panelClass = 'loading-modal';
    dialogChargingConfig.data = { status: 1 };
  
    // Abre el modal
    this.dialogChargingRef = this.dialog.open(ChargingModalComponent, dialogChargingConfig);
  
    // Escucha si el usuario cierra el modal (por ejemplo, con la "X")
    this.dialogChargingRef.afterClosed().subscribe(() => {
      this.deactiveLoading(); // opcional: si el usuario lo cierra manualmente
    this.dialogChargingRef = null;
    });
}
  deactiveLoading(){
    if (this.dialogChargingRef) {
      this.dialogChargingRef.close();
    }
  }
  
  showErrorModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'error-modal';
    const dialogRef = this.dialog.open(MessageEmptyErrorComponent, dialogConfig);
    // Asignar input después de abrir el diálogo
    dialogRef.componentInstance.messageError = this.errorsMessageMassExcel;
  
  }
  showAddCarModal() {
    this.exit();
    this.deactiveLoading();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'check-stock'
    let dialogRef = this.dialog.open(MessageEmptyErrorComponent, dialogConfig);
    // Asignar input después de abrir el diálogo
    dialogRef.componentInstance.messageError = this.exitMessageMassExcel;
    dialogRef.afterClosed().subscribe(
      (data: any) => {
        if(this.router.url === "/main/subir-pedido"){
          this.router.navigate(['/main/confirmacion']);
          return
        } else {
          this._gtmEventService.addProductCartEvent("ENTENDIDO", this.uploadProducts);
          this.router.navigate(['/tienda/mi-carrito']);
          return;
        }
      }
    );
  
  }
  activeFlag(){
    this.flagQuantity = true;
  }
  deactiveFlag(){
    this.flagQuantity = false;
  }
  searchSpecialCharacter(text: string){
    const Patron = "[!\"·$%&/()=¿¡?'_:;,|@#€*+.]";
    return RegExp(Patron).test(text);
  }
  
  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
  
}

